import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { fmtCurrencyFull } from "@/lib/format";

export default function YearByYearTable({ result }) {
  const [open, setOpen] = useState(false);
  if (!result) return null;
  const rows = result.monte_carlo.map((d, i) => ({
    age: d.age,
    simple: result.simple[i]?.balance ?? null,
    p10: d.p10,
    p50: d.p50,
    p90: d.p90,
  }));

  return (
    <div data-testid="year-table-wrap" className="bg-white border border-[#E5E2DC] rounded-2xl">
      <button
        data-testid="btn-toggle-table"
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between px-6 py-5"
      >
        <div className="text-left">
          <div className="text-[11px] tracking-[0.2em] uppercase text-[#5C6B62] font-semibold">
            Detail
          </div>
          <div className="font-display text-lg text-[#1C2B23]">Year-by-year balance</div>
        </div>
        <ChevronDown
          className={`transition-transform text-[#5C6B62] ${open ? "rotate-180" : ""}`}
          size={18}
        />
      </button>
      {open && (
        <div data-testid="year-table" className="border-t border-[#E5E2DC] overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-[#F0EFEA]/60">
              <tr>
                <th className="px-4 py-3 text-left text-[10px] tracking-[0.22em] uppercase text-[#5C6B62] font-semibold">Age</th>
                <th className="px-4 py-3 text-right text-[10px] tracking-[0.22em] uppercase text-[#5C6B62] font-semibold">Simple</th>
                <th className="px-4 py-3 text-right text-[10px] tracking-[0.22em] uppercase text-[#5C6B62] font-semibold">P10</th>
                <th className="px-4 py-3 text-right text-[10px] tracking-[0.22em] uppercase text-[#5C6B62] font-semibold">Median</th>
                <th className="px-4 py-3 text-right text-[10px] tracking-[0.22em] uppercase text-[#5C6B62] font-semibold">P90</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.age} className="border-t border-[#E5E2DC]">
                  <td className="px-4 py-2.5 text-[#1C2B23] font-mono-num">{r.age}</td>
                  <td className="px-4 py-2.5 text-right text-[#1C2B23] font-mono-num">{fmtCurrencyFull(r.simple)}</td>
                  <td className="px-4 py-2.5 text-right text-[#5C6B62] font-mono-num">{fmtCurrencyFull(r.p10)}</td>
                  <td className="px-4 py-2.5 text-right text-[#2B5339] font-mono-num font-medium">{fmtCurrencyFull(r.p50)}</td>
                  <td className="px-4 py-2.5 text-right text-[#5C6B62] font-mono-num">{fmtCurrencyFull(r.p90)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
